var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "job-application-accordion card" },
    [
      _c("div", [
        _c("div", { staticClass: "grid-x grid-padding-y border-b" }, [
          _c("div", { staticClass: "cell auto pl-20 pt-20 pb-10" }, [
            _c("span", { staticClass: "f-15 bold title" }, [
              _vm._v("Your Job Applications  "),
              this.jobApplications.length > 5
                ? _c(
                    "a",
                    {
                      attrs: { href: "javascript:void(0)" },
                      on: { click: _vm.toggleShowAll }
                    },
                    [_vm._v(_vm._s(_vm.showAll ? "Show less" : "See all"))]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cell shrink pr-20 pt-20" }, [
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    _vm.open = !_vm.open
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "fa",
                  class: _vm.open ? "fa-chevron-up" : "fa-chevron-down"
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.open,
                  expression: "open"
                }
              ],
              staticClass: "cell small-12 p-0"
            },
            [
              _c(
                "table",
                { staticClass: "table-job-applications show-for-large" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.displayedJobApplications, function(
                      jobApplication
                    ) {
                      return _c("tr", { key: jobApplication.id }, [
                        _c("td", [
                          _c("div", { staticClass: "grid-x grid-margin-x" }, [
                            _c("div", { staticClass: "cell shrink" }, [
                              jobApplication.application.job
                                ? _c("div", { staticClass: "ml-20" }, [
                                    jobApplication.application.job &&
                                    jobApplication.application.job
                                      .external_logo_path
                                      ? _c("img", {
                                          staticClass: "company-logo",
                                          attrs: {
                                            src:
                                              jobApplication.application.job
                                                .external_logo_path,
                                            alt: "Company Logo"
                                          }
                                        })
                                      : _c("img", {
                                          staticClass: "company-logo",
                                          attrs: {
                                            src: "/img/icons/merchant.png",
                                            alt: "Merchant Logo"
                                          }
                                        })
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "cell auto" }, [
                              jobApplication.application.job
                                ? _c("div", [
                                    jobApplication.application.job.requisition
                                      ? _c(
                                          "div",
                                          { staticClass: "job-title" },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(
                                                  jobApplication.application.job
                                                    .requisition.display_title
                                                ) +
                                                "\n                                            "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "job-title" },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(
                                                  jobApplication.application.job
                                                    .title
                                                ) +
                                                "\n                                            "
                                            )
                                          ]
                                        ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "job-location" }, [
                                      _c("img", {
                                        staticClass: "job-icons",
                                        attrs: {
                                          src: "/img/icons/location_on.png"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            jobApplication.application.job
                                              .location
                                          )
                                        )
                                      ])
                                    ])
                                  ])
                                : _vm._e()
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          jobApplication.application.job
                            ? _c("span", [
                                _vm._v(
                                  "\n                                    #" +
                                    _vm._s(
                                      jobApplication.application.job
                                        .requisition_id
                                    ) +
                                    "\n                                "
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            ["failed", "recycled"].includes(
                              jobApplication.application.status
                            )
                              ? [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "job-application-status",
                                      class: {
                                        "text-danger": ["failed"].includes(
                                          jobApplication.application.status
                                        )
                                      }
                                    },
                                    [
                                      jobApplication.application.status
                                        ? _c("strong", [
                                            _vm._v(
                                              "\n                                            Unsuccessful -\n                                        "
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  ),
                                  _vm._v(" "),
                                  jobApplication.application.fail_reason
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              jobApplication.application
                                                .fail_reason
                                            ) +
                                            "\n                                    "
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              : [
                                  jobApplication.statusTitle === "Incomplete"
                                    ? _c(
                                        "div",
                                        { staticClass: "text-warning" },
                                        [
                                          _vm._v(
                                            _vm._s(jobApplication.statusTitle) +
                                              " "
                                          ),
                                          jobApplication.stepToFinishMessage
                                            ? _c(
                                                "span",
                                                { staticClass: "text-black" },
                                                [
                                                  _vm._v(
                                                    "- " +
                                                      _vm._s(
                                                        jobApplication.stepToFinishMessage
                                                      )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  jobApplication.statusTitle === "Pending"
                                    ? _c("div", [
                                        _vm._v(
                                          _vm._s(jobApplication.statusTitle)
                                        )
                                      ])
                                    : _vm._e()
                                ]
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          [
                            jobApplication.statusTitle === "Incomplete"
                              ? _c("ProgressKnob", {
                                  staticClass: "knob",
                                  attrs: {
                                    currentStep:
                                      jobApplication.application.completed_step,
                                    totalSteps:
                                      jobApplication.application.total_step
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _c("div", { staticClass: "action-buttons" }, [
                            !["failed", "recycled"].includes(
                              jobApplication.application.status
                            )
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "btn btn-hover-gray",
                                    attrs: {
                                      href: jobApplication.stepLink
                                        ? jobApplication.stepLink
                                        : "/candidate/job-applications/view/" +
                                          jobApplication.application.id
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        Continue "
                                    ),
                                    _c("i", {
                                      staticClass: "fa-solid fa-chevron-right"
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !["failed", "recycled"].includes(
                              jobApplication.application.status
                            )
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn text-danger ml-10 btn-hover-red",
                                    on: {
                                      click: function($event) {
                                        return _vm.withdrawApplication(
                                          jobApplication.application.id
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        Cancel\n                                    "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            ["failed"].includes(
                              jobApplication.application.status
                            ) &&
                            jobApplication.application.is_reappliable &&
                            _vm.isRequisitionActive(
                              jobApplication.application.job.requisition
                                .closing_date
                            )
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn btn-reapply ml-10 btn-hover-gray",
                                    attrs: {
                                      href:
                                        "/candidate/job-applications/reapply/" +
                                        jobApplication.application.id
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        Reapply\n                                    "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ])
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hide-for-large mt-10 p-20" },
                _vm._l(_vm.jobApplications, function(jobApplication) {
                  return _c(
                    "div",
                    {
                      key: jobApplication.id,
                      staticClass: "grid-x grid-padding-y border-b"
                    },
                    [
                      _c("div", { staticClass: "cell small-2" }, [
                        jobApplication.application.job
                          ? _c("div", [
                              jobApplication.application.job &&
                              jobApplication.application.job.external_logo_path
                                ? _c("img", {
                                    staticClass: "company-logo",
                                    attrs: {
                                      src:
                                        jobApplication.application.job
                                          .external_logo_path,
                                      alt: "Company Logo"
                                    }
                                  })
                                : _c("img", {
                                    staticClass: "company-logo",
                                    attrs: {
                                      src: "/img/icons/merchant.png",
                                      alt: "Merchant Logo"
                                    }
                                  })
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "cell small-10" }, [
                        jobApplication.application.job
                          ? _c("div", [
                              jobApplication.application.job.requisition
                                ? _c("div", { staticClass: "job-title" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          jobApplication.application.job
                                            .requisition.display_title
                                        ) +
                                        "\n                                "
                                    )
                                  ])
                                : _c("div", { staticClass: "job-title" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          jobApplication.application.job.title
                                        ) +
                                        "\n                                "
                                    )
                                  ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "job-location" }, [
                                _c("img", {
                                  staticClass: "job-icons",
                                  attrs: { src: "/img/icons/location_on.png" }
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      jobApplication.application.job.location
                                    )
                                  )
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        jobApplication.application.job
                          ? _c("div", [
                              _vm._v(
                                "\n                                #" +
                                  _vm._s(
                                    jobApplication.application.job
                                      .requisition_id
                                  ) +
                                  "\n                            "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "grid-x grid-padding-x" }, [
                          _c(
                            "div",
                            { staticClass: "cell small-12" },
                            [
                              ["failed", "recycled"].includes(
                                jobApplication.application.status
                              )
                                ? [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "job-application-status",
                                        class: {
                                          "text-danger": ["failed"].includes(
                                            jobApplication.application.status
                                          )
                                        }
                                      },
                                      [
                                        jobApplication.application.status
                                          ? _c("strong", [
                                              _vm._v(
                                                "\n                                                Unsuccessful -\n                                            "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    jobApplication.application.fail_reason
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                jobApplication.application
                                                  .fail_reason
                                              ) +
                                              "\n                                        "
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                : [
                                    jobApplication.statusTitle === "Incomplete"
                                      ? _c(
                                          "div",
                                          { staticClass: "text-warning" },
                                          [
                                            _vm._v(
                                              _vm._s(jobApplication.statusTitle)
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    jobApplication.statusTitle === "Pending"
                                      ? _c("div", [
                                          _vm._v(
                                            _vm._s(jobApplication.statusTitle)
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "grid-x grid-padding-x mt-20" },
                          [
                            jobApplication.statusTitle === "Incomplete"
                              ? _c(
                                  "div",
                                  { staticClass: "cell small-2" },
                                  [
                                    _c("ProgressKnob", {
                                      staticClass: "knob",
                                      attrs: {
                                        currentStep:
                                          jobApplication.application
                                            .completed_step,
                                        totalSteps:
                                          jobApplication.application.total_step
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "cell",
                                class: {
                                  "small-10":
                                    jobApplication.statusTitle === "Incomplete"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "action-buttons mt-0" },
                                  [
                                    !["failed", "recycled"].includes(
                                      jobApplication.application.status
                                    )
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn btn-hover-gray ml-10",
                                            attrs: {
                                              href:
                                                "/candidate/job-applications/view/" +
                                                jobApplication.application.id
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            Continue "
                                            ),
                                            _c("i", {
                                              staticClass:
                                                "fa-solid fa-chevron-right"
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !["failed", "recycled"].includes(
                                      jobApplication.application.status
                                    )
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn text-danger ml-10 btn-hover-red",
                                            on: {
                                              click: function($event) {
                                                return _vm.withdrawApplication(
                                                  jobApplication.application.id
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            Cancel\n                                        "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    ["failed"].includes(
                                      jobApplication.application.status
                                    ) &&
                                    jobApplication.application.is_reappliable &&
                                    _vm.isRequisitionActive(
                                      jobApplication.application.job.requisition
                                        .closing_date
                                    )
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn btn-reapply ml-10 btn-hover-gray",
                                            attrs: {
                                              href:
                                                "/candidate/job-applications/reapply/" +
                                                jobApplication.application.id
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            Reapply\n                                        "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(1, true)
                    ]
                  )
                }),
                0
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("confirm-withdraw-application-modal", {
        ref: "confirmWithdrawApplicationModal",
        attrs: {
          "job-application-id": _vm.currentJobApplicationId,
          "csrf-token": _vm.csrfToken
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { staticStyle: { width: "30%" } }, [
          _c("div", { staticClass: "ml-20 mb-10 br-l-10" }, [_vm._v("Job")])
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "10%" } }, [
          _c("div", { staticClass: "mb-10" }, [_vm._v("Ref. No")])
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "32%" } }, [
          _c("div", { staticClass: "mb-10" }, [_vm._v("Status")])
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "5%" } }, [
          _c("div", { staticClass: "mb-10" }, [_vm._v(" ")])
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "10%" } }, [
          _c("div", { staticClass: "mr-20 br-r-10 mb-10" }, [_vm._v("Action")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell small-12" }, [
      _c("hr", { staticClass: "mobile-divider mt-5 mb-5" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-294bf0a8", { render: render, staticRenderFns: staticRenderFns })
  }
}